import { motion } from "framer-motion";
import { Logo } from "./Logo";

export const Nav = () => (
  <motion.header
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.8, delay: 0.2 }}
    className="fixed top-0 left-0 right-0 z-50 border-b rule bg-[#f9f9f7]/90 backdrop-blur-sm"
    data-testid="site-nav"
  >
    <div className="mx-auto max-w-[1440px] px-6 md:px-12 h-14 flex items-center justify-between">
      <a
        href="/"
        className="flex items-center"
        data-testid="nav-logo"
        aria-label="Frontage home"
      >
        <Logo variant="wide" animate className="text-[16px] md:text-[21px]" />
      </a>
      <div className="flex items-center gap-4 md:gap-8">
        <a
          href="mailto:hello@frontagedigital.com.au"
          onClick={(e) => {
            if (window.location.pathname === "/") {
              e.preventDefault();
              window.dispatchEvent(new CustomEvent("sheet-goto", { detail: 3 }));
            }
          }}
          className="label link-hover-underline whitespace-nowrap"
          data-testid="nav-contact-link"
        >
          Contact
        </a>
        <a
          href="https://clients.frontagedigital.com.au"
          className="label link-hover-underline whitespace-nowrap"
          data-testid="nav-client-login"
        >
          Client login
        </a>
      </div>
    </div>
  </motion.header>
);
